"use client";

import { Shield, Clock, ThumbsUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseAPlusFire() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = [{
    icon: Shield,
    title: "Certified & Trusted",
    description: "Family-owned with certified, insured technicians providing reliable fire protection services."
  }, {
    icon: Clock,
    title: "Fast Response",
    description: "Direct contact with Mike means rapid response times for inspections and emergency service calls."
  }, {
    icon: ThumbsUp,
    title: "Honest Service",
    description: "No upselling, just honest work and straightforward pricing from owner-technician Mike."
  }];
  return <section className="bg-dark-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div ref={ref1} data-index={0} className={`transition-all duration-[var(--duration-slow)] ${isVisible1 ? "animate-fade-in-up" : "opacity-0"}`}>
            <Card className="bg-primary/20 border-primary/30 hover:bg-primary/30 transition-all duration-[var(--duration-medium)] group h-full">
              <CardHeader className="text-center">
                <div className="mx-auto mb-4 transition-transform duration-[var(--duration-medium)] group-hover:-translate-y-0.5">
                  <Shield className="w-16 h-16 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-foreground-dark text-xl font-bold">
                  {benefits[0].title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-foreground-dark/90 text-center">
                  {benefits[0].description}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={ref2} data-index={1} className={`transition-all duration-[var(--duration-slow)] ${isVisible2 ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
            <Card className="bg-primary/20 border-primary/30 hover:bg-primary/30 transition-all duration-[var(--duration-medium)] group h-full">
              <CardHeader className="text-center">
                <div className="mx-auto mb-4 transition-transform duration-[var(--duration-medium)] group-hover:-translate-y-0.5">
                  <Clock className="w-16 h-16 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-foreground-dark text-xl font-bold">
                  {benefits[1].title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-foreground-dark/90 text-center">
                  {benefits[1].description}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={ref3} data-index={2} className={`transition-all duration-[var(--duration-slow)] ${isVisible3 ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
            <Card className="bg-primary/20 border-primary/30 hover:bg-primary/30 transition-all duration-[var(--duration-medium)] group h-full">
              <CardHeader className="text-center">
                <div className="mx-auto mb-4 transition-transform duration-[var(--duration-medium)] group-hover:-translate-y-0.5">
                  <ThumbsUp className="w-16 h-16 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-foreground-dark text-xl font-bold">
                  {benefits[2].title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-foreground-dark/90 text-center">
                  {benefits[2].description}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}